import React, { useEffect, useState } from "react";
import Input from "../Form/Input";
import axios from "axios";

const RequestInfo = ({ requestInfoRef }) => {
  const [pincode, setPincode] = useState("");
  const [pincodeData, setPincodeData] = useState(null);
  const [state, setState] = useState("AP");
  const [stateData, setStateData] = useState({});
  const [CityData, setCityData] = useState({});
  const [cityFiltered, setCityFiltered] = useState([]);
  const [city, setCity] = useState("");
  const [showCityList, setShowCityList] = useState(true);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
    state: "",
    city: "",
    pincode: "",
  });

  useEffect(() => {
    if (city.length < 4) {
      setShowCityList(true);
    } else {
      setShowCityList(false);
    }

    if (city) {
      const getCityName = CityData.filter((item) => {
        return item.name.toLowerCase().includes(city.toLowerCase());
      });

      setCityFiltered(getCityName);
    }
  }, [city]);

  const onChangeHandler = (e) => {
    const { name, value } = e.target;

    const getStateName = stateData.find((item) => {
      return item.id === Number(value);
    });

    if (name === "city") {
      setCity(value);
    }

    if (getStateName) {
      setState(getStateName);
      setFormData({ ...formData, [name]: getStateName.name });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();
    console.log("Form submitted", formData);
  };

  // useEffect(() => {
  //   if (pincodeData && pincodeData[0].Status === "Success") {
  //     const { Division, State } = pincodeData[0].PostOffice[0];
  //     setFormData((prev) => ({
  //       ...prev,
  //       state: State,
  //       city: Division,
  //     }));
  //   }
  // }, [pincodeData]);

  // useEffect(() => {
  //   const fetchState = async () => {
  //     if (pincode) {
  //       getState(pincode);
  //     }
  //   };
  //   fetchState();
  //   getStateByCountry();
  //   getCitiesByState();
  // }, [pincode, state]);

  useEffect(() => {
    getStateByCountry();
    getCitiesByState();
  }, [pincode, state, city]);

  const getStateByCountry = async () => {
    const data = await axios.get(
      `https://api.countrystatecity.in/v1/countries/IN/states`,
      {
        headers: {
          "Content-Type": "application/json",
          "X-CSCAPI-KEY":
            "bTFEb2FRdUQyNk1JcmlsY2JnbHo1WFRwNUpKR3FiWENPY1lrS0E1Rg==",
        },
      }
    );
    setStateData(data.data);
  };

  const getCitiesByState = async () => {
    const data = await axios.get(
      `https://api.countrystatecity.in/v1/countries/IN/states/${
        state.iso2 ? state.iso2 : state
      }/cities`,
      {
        headers: {
          "Content-Type": "application/json",
          "X-CSCAPI-KEY":
            "bTFEb2FRdUQyNk1JcmlsY2JnbHo1WFRwNUpKR3FiWENPY1lrS0E1Rg==",
        },
      }
    );
    setCityData(data.data);
  };

  // const getState = async (value) => {
  //   setPincode(value);

  //   const data = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
  //   const response = await data.json();
  //   setPincodeData(response);
  // };

  return (
    <form
      ref={requestInfoRef}
      onSubmit={submitHandler}
      className="sm:w-[80%] mx-auto relative"
    >
      <h2 className="sm:text-3xl text-2xl font-semibold text-center sm:pb-8 pb-4">
        Request Info
      </h2>
      <div className="border border-lightGray/10 rounded sm:p-8 xs:p-1 p-3 flex flex-col w-full sm:gap-5 gap-3 text-black">
        {/* Name And Email */}
        <div className="flex xs:flex-row flex-col w-full sm:gap-5 gap-3">
          <Input
            type={"text"}
            label={"Name"}
            placeHolder={"Enter your name"}
            id={"name"}
            value={formData.name}
            name={"name"}
            onChangeHandler={onChangeHandler}
            styling={
              "sm:p-2 p-1 border border-light rounded focus:outline-none "
            }
          />

          <Input
            type={"text"}
            label={"Email"}
            placeHolder={"email address"}
            id={"email"}
            value={formData.email}
            name={"email"}
            styling={
              "sm:p-2 p-1 border border-light rounded focus:outline-none"
            }
            onChangeHandler={onChangeHandler}
          />
        </div>
        {/* Phone And Company */}

        <div className="flex  xs:flex-row flex-col w-full sm:gap-5 gap-3">
          <Input
            type={"text"}
            label={"Phone"}
            placeHolder={"Phone number"}
            id={"phone"}
            value={formData.phone}
            name={"phone"}
            onChangeHandler={onChangeHandler}
            styling={
              "sm:p-2 p-1 border border-light rounded focus:outline-none"
            }
          />

          <Input
            type={"text"}
            label={"Company"}
            placeHolder={"Company name"}
            id={"company"}
            value={formData.company}
            name={"company"}
            onChangeHandler={onChangeHandler}
            styling={
              "sm:p-2 p-1 border border-light rounded focus:outline-none"
            }
          />
        </div>

        <div className="flex  xs:flex-row flex-col w-full items-center sm:gap-5 gap-3">
          {/* {pincodeData && pincodeData[0].Status === "Success" && (
            <div>
            <Input
            type={"text"}
            label={"State"}
            placeHolder={"Enter your state"}
            id={"state"}
            value={formData.state}
                name={"state"}
                styling={"sm:p-2 p-1 border border-light rounded focus:outline-none "}
                />
                
                <Input
                type={"text"}
                label={"City"}
                placeHolder={"City name"}
                id={"city"}
                value={formData.city}
                name={"city"}
                styling={"sm:p-2 p-1 border border-light rounded focus:outline-none"}
                />
                </div>
                )} */}

          <div className="flex flex-col gap-2 w-full">
            <label htmlFor="state" className="text-white">
              State{" "}
            </label>
            <select
              className="p-2 border border-light rounded focus:outline-none w-full"
              name="state"
              id="state"
              onChange={onChangeHandler}
            >
              <option>Select State </option>
              {stateData.length > 0 &&
                stateData.map((item) => {
                  // console.log(item);
                  return (
                    <option value={item.id} key={item.id}>
                      {item.name}
                    </option>
                  );
                })}
            </select>
          </div>

          {/* City Input */}

          <div className="flex flex-col gap-2 w-full relative">
            <Input
              type="text"
              label="City"
              placeHolder="City name"
              onChangeHandler={onChangeHandler}
              value={formData.city}
              id="city"
              name="city"
              autoComplete="off"
              styling="p-2 border border-light text-black rounded focus:outline-none w-full"
            />

            {state?.name && (
              <div className="bg-white max-h-44 overflow-y-auto overflow-x-hidden flex flex-col gap-2 absolute top-20 left-0 w-full z-10">
                {cityFiltered.length > 0 &&
                  cityFiltered.map((item) => {
                    // console.log(item.name);
                    return (
                      showCityList && (
                        <button
                          type="button"
                          className={`bg-white w-full p-2  hover:bg-lightGray text-left`}
                          key={item.id}
                          value={item.name}
                          onClick={(e) => {
                            setCity(e.target.value);
                            setFormData({ ...formData, city: e.target.value });
                            setShowCityList(false);
                          }}
                        >
                          {item.name}
                        </button>
                      )
                    );
                  })}
              </div>
            )}
          </div>

          <Input
            type={"text"}
            label={"Pincode"}
            placeHolder={"Pincode"}
            onChangeHandler={onChangeHandler}
            value={formData.pincode}
            id={"pincode"}
            name={"pincode"}
            styling={
              "p-2 w-full border border-light rounded focus:outline-none"
            }
          />
        </div>

        <Input
          type={"textarea"}
          label={"Message"}
          cols={"30"}
          rows={"3"}
          placeHolder={"Message or query"}
          id={"message"}
          onChangeHandler={onChangeHandler}
          value={formData.message}
          name={"message"}
          styling={"sm:p-2 p-1 border border-light rounded focus:outline-none"}
        />

        <button
          type="submit"
          className="border border-lightGray xs:p-3 p-1 rounded text-white"
        >
          Submit
        </button>
      </div>
    </form>
  );
};

export default RequestInfo;
